import React from 'react';
import EmergencySpokePage from './EmergencySpokePage';

// Spoke: Zahn abgebrochen/ausgeschlagen — 60-Minuten-Countdown-Warnbox (Avulsion).
const EmergencyBrokenToothPage: React.FC = () => (
  <EmergencySpokePage
    routeKey="emergency-broken-tooth"
    namespace="brokenTooth"
    warnboxVariant="countdown"
    medicalCondition="Dental trauma"
  />
);

export default EmergencyBrokenToothPage;
